import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import BuilderComponent from 'components/BuilderComponent/BuilderComponent';
import { Wrapper } from 'components/Layout/Layout';
import { trackFbEvents } from 'functions/fbPixel';
import { useQueryParams } from 'hooks/useQueryParams';
import { userRoles } from 'constants/users';

export default function LandingPage() {
  const { 'no-redirect': noRedirect } = useQueryParams();
  const navigate = useNavigate();

  const { userRole } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!noRedirect && userRole && userRole !== userRoles.CANDIDATE) navigate('/tests');
  }, [noRedirect, userRole, navigate]);

  return (
    <Wrapper>
      <BuilderComponent
        entries={{
          de: '13bf419a719f408d876ec321a21eebc7',
          en: 'cf2e8b9d21134d86b89f373b74ead7af',
          sv: 'aec6c2e0077441db87deecb2ba4d1295',
        }}
        context={{
          trackStartToCode: () => trackFbEvents('StartToCode'),
        }}
      />
    </Wrapper>
  );
}
